import { useSponsorshipStore } from "./sponsorshipStore";

export const createSponsorshipFromStore = () => {
  return {
    sponsorId: useSponsorshipStore.getState().sponsorId,
    sponsorNameFirstLetters:
      useSponsorshipStore.getState().sponsorNameFirstLetters,
  };
};
